<template>
<!-- 选择服务器 -->
    <div class="modal-content " v-drag>
        <div class="modal-header head"  >
            <span class="modal-title">--选择角色--</span> 
            <span aria-hidden="true" class="modal-span" @click="close">&times;</span> 
        </div>
        <div class="modal-body">
            <form class="form-inline">
                <div class="form-group">
                    <label for="exampleInputName2" class="lab">分区</label>
                    <select class="form-control" v-model="selected">
                        <option disabled value="">请选择</option>
                        <option v-for="(data,index) in res_data" :key="index" >{{data.fld_server_id}}</option>
                    </select>
                </div>
                <div class="form-group ">
                    <label for="exampleInputEmail2" class="lab">角色</label>
                    <input type="email" class="form-control" placeholder="角色名" v-model="role_name">
                </div>
                <button type="button" class="btn btn-default-determine" @click="search_sever(records,page)">查询</button>
            </form>
            <div style="height:500px">
                <table>
                    <div>
                        <table class="table table-hover table-bordered  text-nowrap ">
                            <thead>
                                <tr>
                                  <th v-if="head_data.length">
                                    <div class="td-width" style="width:40px ,text-align:center">
                                        <input type="checkbox" v-model="general_checkbox" @change="select_general_checkbox">
                                      </div>
                                  </th>  
                                  <th v-for="(head,index) in head_data" :key="index">
                                    <div class="td-width" :style="{width:th_width[index]+'px'}">
                                      {{head.Comment}}
                                      </div>
                                  </th>                          
                                </tr>
                            </thead>
                        </table>
                    </div>                        
                    <div class="scroll-tbody">
                        <table class="table table-hover table-bordered  text-nowrap ">
                            <tbody>
                              <tr v-for="(rows,index) in body_data" :key="index" @click="select_checkbox(rows,index)">
                                <td>
                                  <div class="td-width" style="width:40px ,text-align:center">
                                    <input type="checkbox" :value="selected+','+rows.fld_role_id" v-model="list_checkbox">
                                  </div>
                                </td>  
                                <td v-for="(rows_list,index) in head_data" :key="index" >
                                  <div class="td-width" :style="{width:th_width[index]+'px'}" :title="rows[rows_list.Name]">
                                    {{rows[rows_list.Name]}}
                                  </div>
                                </td>                            
                              </tr>                                
                            </tbody>
                    </table>
                    </div>
                </table>
       <!-- 分页 -->
                <div class="total-page footer" v-if="total&&total>1">
                    <div>
                        <i class="fa fa-fast-backward" @click="home_page"></i>
          	    		<i class="fa fa-backward" @click="previous_page"></i>
                        <span class="page">{{'第'+page+'页'}}</span>
                        <span class="page">{{'共'+total+'页'}}</span>
          	    		<i class="fa fa-forward" @click="next_page"></i>
          	    		<i class="fa fa-fast-forward" @click="Last_pag"></i>
                    </div>
          	    </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default btn-default-close" style="margin-right:85%" data-dismiss="modal" @click="cancel">取消</button>
                <button type="button" class="btn btn-default-determine" @click="confirm">确认</button>
            </div>
		</div>
    </div>
</template>
<script>
import tool from '../tool/tool.js'
import api from '../api/index.js'
export default {
  name:'sel1',
  data () {
    return {
      //选择框中数据
      selected: '',
      //角色名
      role_name:'',
      //区服数据
      res_data:'',
      //表头数据
      head_data:[],
      //表体数据
      body_data:null,
      //页数的累加和累减
      num:1,
      //显示的条数
      records:18,
      //初始显示的页数
      page:1,
      //总页数
      total:null,
      //定义每列的宽度
      th_width:[],
      userInfo:window.sessionStorage.getItem('userInfo'),
      //区服id
      change_area_service_id:null,
      //列表复选框
      list_checkbox:[],
      //总复选框
      general_checkbox:null
    }
  },
  props: {
    ppr_action:String,
    ppr_action_param:String,
    sle_zone:String,
    area_service_id:String,
    rule_data:String,
  },
  watch:{
    sle_zone(n,o){
    //   console.log(n,o)
      if(this.body_data){
        this.search_sever(this.records,1)
      }
    }
  },
  created () {
    this.regional_service_data();
  },
  mounted () {
    this.show_records();
    this.edit_select_checkbox()
  },
  methods: {
    //编辑时如果有值就把相应的复选框选中
    edit_select_checkbox(){          
        if(this.rule_data){
            var rule_data=JSON.parse(this.rule_data);
            rule_data.forEach((item,index)=>{
                this.list_checkbox.push(item.SID+','+item.RID)
            })
        }
    },
    //总复选框
    select_general_checkbox(){
        if(this.general_checkbox){
            this.body_data.forEach((item,index)=>{
                this.list_checkbox.push(this.selected+','+item.fld_role_id)
            })
        }else{
            var data=this.body_data;
            var list=this.list_checkbox;
            for(var j=0;j<data.length;j++){
                for(var i=0;i<list.length;i++){
                    if(this.selected+','+data[j].fld_role_id===list[i]){
                        var index = list.indexOf(list[i]); 
                        if (index > -1) { 
                            this.list_checkbox.splice(index, 1);
                        }
                    }
                }
            }
                
        }
          
    },
    //判断总复选框的选中（当列表有选中项的时候总复选框跟着选中）
    is_select_checkbox(rows){         
        if(rows.length>0&&this.list_checkbox.length>0){
            this.general_checkbox=false
            for(var i=0;i<rows.length;i++){
                if(this.list_checkbox.some((test,index)=>{return test==this.selected+','+rows[i].fld_role_id})){
                    this.general_checkbox=true
                    return
                }
            }
        }else{
            this.general_checkbox=false  
            return
        }
    },
    //点击列表选中复选框
    select_checkbox(rows,index){
        if(this.list_checkbox.length==0){
            this.list_checkbox.push(this.selected+','+rows.fld_role_id)
        }else if(this.list_checkbox.length&&this.list_checkbox.every((item,list_index)=>{return this.selected+','+rows.fld_role_id!=item})){
            this.list_checkbox.push(this.selected+','+rows.fld_role_id)
        }else{
            this.list_checkbox=this.list_checkbox.filter((item,list_index)=>{
                return this.selected+','+rows.fld_role_id!=item
            })
        }
        this.is_select_checkbox(this.body_data)
    },
    //更新时区
	update_timezone(fields,res){
		//更新时区
		if(res!=undefined){
			this.project_data = res.data;
				fields.map((ite,index,arr)=>{
					if(ite.FieldType=="datetime"||ite.FieldType=="timestamp"){
						 res.forEach((item,index)=>{
							item[ite.Name]=tool.datetime2zone_x(item[ite.Name],this.sle_zone);
						})
					}
				});
			this.body_data = res;			
		};
	},
    //动态计算显示的条数
    show_records(){
        this.records=parseInt((window.screen.height-350)/43-1);
    },
    //请求区服数据
    async regional_service_data(){
        let res=await tool.async_error(api.regional_service_data('/bin/Sandbox/Launcher/tbl_server/datas',{userInfo:this.userInfo}))
        this.res_data=res.data;
        this.selected=this.res_data[0].fld_server_id;
    },
    //取消按钮
    cancel(){
        this.general_checkbox=false;
        this.list_checkbox=[];
    },
    close(){
      this.$emit('close_project')
    },
    //查询列表、
    async search_sever(records,page){
        if(this.selected){
          // console.log(this.userInfo)
          this.userInfo=JSON.stringify({"fld_record_id":18,"fld_name":"admin","fld_groups":"","fld_login_ip":"180.88.96.77","fld_login_time":"2021-12-14 10:26:55","fld_deleted":0,"fld_super":1,"fld_isappkey":0})
            let time=new Date().getTime();        
            let parameter={_search: true,nd: time,rows: records,page: page,sidx: 'fld_record_id',sord: 'desc',searchField: '',searchString: '',searchOper: ''};
            parameter.filters={groupOp:'OR',rules:[]};
            // let parameter={_search: false,nd: time,rows: records,page: page,sidx: 'fld_record_id',sord: 'desc',searchField: '',searchString: '',searchOper: ''};
            // console.log(this.rule_name)
            if(this.role_name){             
                var role_name_obj={field:'fld_role_name',op:'cn',data:this.role_name};
                var role_id_obj={field:'fld_role_id',op:'cn',data:this.role_name}
                parameter.filters.rules.push(role_name_obj);
                parameter.filters.rules.push(role_id_obj)
            }else{
               parameter={_search: false,nd: time,rows: records,page: page,sidx: 'fld_record_id',sord: 'desc',searchField: '',searchString: '',searchOper: ''};
            }

            parameter.filters=JSON.stringify(parameter.filters)
            // parameter.userInfo=window.sessionStorage.getItem('userInfo');
            parameter.userInfo=this.userInfo
            let url='http://152.136.167.127:8000/bin/Sandbox/Sandbox'
                let url1='http://121.36.101.30:19210/bin/Sandbox/Sandbox'
                let url2='http://47.241.50.114:19112/bin/Sandbox/Sandbox'
                let serch_server=async (url)=>{
                  let res=await tool.async_error(api.search_sever(url+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
                  if(res.data.FIELDS.length>0){
                      this.head_data=res.data.FIELDS.filter((item,index)=>{
                          return item.Name=='fld_role_id'||item.Name=='fld_role_name'||item.Name=='fld_user_id'
                      })
                  }
                  var res2=await tool.async_error(api.search_sever_body(url+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
                  this.body_data=res2.data.rows;
                  if(this.list_checkbox.length>0){
                      this.is_select_checkbox(this.body_data)
                  }  
                  this.total=Math.floor(Number(res2.data.total));
                  this.page=res2.data.page;
                  this.update_timezone(this.head_data,this.body_data);
                  this.th_width=tool.calculated_width(this.head_data)
                };
            // if(this.role_name){//根据查询字段渲染数据
                
                if(this.selected==1000||this.selected==1001||this.selected==1002){ 
                  // let res=await tool.async_error(api.search_sever(url1+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
                  // if(res.data.FIELDS.length>0){
                  //     this.head_data=res.data.FIELDS.filter((item,index)=>{
                  //         return item.Name=='fld_role_id'||item.Name=='fld_role_name'||item.Name=='fld_user_id'
                  //     })
                  // }
                  // var res2=await tool.async_error(api.search_sever_body(url1+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
                  // this.body_data=res2.data.rows;
                  // if(this.list_checkbox.length>0){
                  //     this.is_select_checkbox(this.body_data)
                  // }  
                  // this.total=Math.floor(Number(res2.data.total));
                  // this.page=res2.data.page;
                  // this.update_timezone(this.head_data,this.body_data);
                  // this.th_width=tool.calculated_width(this.head_data)
                  serch_server(url1)
                }else if(this.selected>=0&&this.selected<100){
                  // let res=await tool.async_error(api.search_sever(url2+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
                  // if(res.data.FIELDS.length>0){
                  //     this.head_data=res.data.FIELDS.filter((item,index)=>{
                  //         return item.Name=='fld_role_id'||item.Name=='fld_role_name'||item.Name=='fld_user_id'
                  //     })
                  // }
                  // var res3=await tool.async_error(api.search_sever_body(url1+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
                  // this.body_data=res3.data.rows;
                  // if(this.list_checkbox.length>0){
                  //     this.is_select_checkbox(this.body_data)
                  // }  
                  // this.total=Math.floor(Number(res3.data.total));
                  // this.page=res3.data.page;
                  // this.update_timezone(this.head_data,this.body_data);
                  // this.th_width=tool.calculated_width(this.head_data)
                  serch_server(url2)
                }else{
                  // let res=await tool.async_error(api.search_sever(url+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
                  // if(res.data.FIELDS.length>0){
                  //     this.head_data=res.data.FIELDS.filter((item,index)=>{
                  //         return item.Name=='fld_role_id'||item.Name=='fld_role_name'||item.Name=='fld_user_id'
                  //     })
                  // }
                  // var res1=await tool.async_error(api.search_sever_body(url+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
                  // this.body_data=res1.data.rows;
                  // if(this.list_checkbox.length>0){
                  //     this.is_select_checkbox(this.body_data)
                  // }
                  // this.total=Math.floor(Number(res1.data.total));
                  // this.page=res1.data.page;
                  // this.update_timezone(this.head_data,this.body_data);
                  // this.th_width=tool.calculated_width(this.head_data)
                  serch_server(url)
                }    
                
            // }


            // if(!this.role_name){//没有查询字段渲染所有的数据
            //     let parameter={_search: false,nd: time,rows: records,page: page,sidx: 'fld_record_id',sord: 'desc',searchField: '',searchString: '',searchOper: ''};
            //     // parameter.userInfo=window.sessionStorage.getItem('userInfo');
            //     // let url='http://152.136.167.127:8000/bin/Sandbox/Sandbox'
            //     // let url1='http://121.36.101.30:19210/bin/Sandbox/Sandbox'
            //     // let url2='http://47.241.50.114:19112/bin/Sandbox/Sandbox'
            //     if(this.selected==1000||this.selected==1001||this.selected==1002){
            //       // let res=await tool.async_error(api.search_sever(url2+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            //       // if(res.data.FIELDS.length>0){
            //       //     this.head_data=res.data.FIELDS.filter((item,index)=>{
            //       //         return item.Name=='fld_role_id'||item.Name=='fld_role_name'||item.Name=='fld_user_id'
            //       //     })
            //       // }
            //       // let res2=await tool.async_error(api.search_sever_body(url2+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
            //       // // console.log(res1)
            //       // this.body_data=res2.data.rows;
            //       // if(this.list_checkbox.length>0){
            //       //     this.is_select_checkbox(this.body_data)
            //       // }
            //       // this.total=Math.floor(Number(res2.data.total));
            //       // this.page=res2.data.page;
            //       // this.update_timezone(this.head_data,this.body_data);
            //       // this.th_width=tool.calculated_width(this.head_data)
            //       serch_server(url1)
            //     }else if(this.selected>=0&&this.selected<100){
            //       // let res=await tool.async_error(api.search_sever(url1+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            //       // if(res.data.FIELDS.length>0){
            //       //     this.head_data=res.data.FIELDS.filter((item,index)=>{
            //       //         return item.Name=='fld_role_id'||item.Name=='fld_role_name'||item.Name=='fld_user_id'
            //       //     })
            //       // }
            //       // let res3=await tool.async_error(api.search_sever_body(url1+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
            //       // this.body_data=res3.data.rows;
            //       // if(this.list_checkbox.length>0){
            //       //     this.is_select_checkbox(this.body_data)
            //       // }
            //       // this.total=Math.floor(Number(res3.data.total));
            //       // this.page=res3.data.page;
            //       // this.update_timezone(this.head_data,this.body_data);
            //       // this.th_width=tool.calculated_width(this.head_data)
            //       serch_server(url2)
            //     }else{
            //       // let res=await tool.async_error(api.search_sever(url+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            //       // if(res.data.FIELDS.length>0){
            //       //     this.head_data=res.data.FIELDS.filter((item,index)=>{
            //       //         return item.Name=='fld_role_id'||item.Name=='fld_role_name'||item.Name=='fld_user_id'
            //       //     })
            //       // }
            //       // let res1=await tool.async_error(api.search_sever_body(url+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
            //       // this.body_data=res1.data.rows;
            //       // if(this.list_checkbox.length>0){
            //       //     this.is_select_checkbox(this.body_data)
            //       // }
            //       // this.total=Math.floor(Number(res1.data.total));
            //       // this.page=res1.data.page;
            //       // this.update_timezone(this.head_data,this.body_data);
            //       // this.th_width=tool.calculated_width(this.head_data)
            //       serch_server(url)
            //     }
                
            // }
        }
       
    },
    confirm(){
        var data=[];        
        if(this.list_checkbox.length>0){
            this.list_checkbox.forEach((item,index)=>{              
                let data_obj={};
                data_obj.RID=item.split().join().split(',')[1];
                data_obj.SID=item.split().join().split(',')[0];
                data.push(data_obj);
            })
            data=JSON.stringify(data);
            this.$emit('get_role_data',data)
        }
    },
    home_page(){
        if(this.page>1){
            this.search_sever(this.records,1)
        }
    },
    previous_page(){
        if(this.page>1){
            this.num-=1;
            this.search_sever(this.records,this.num)
        }
    },
    next_page(){
        if(this.page<this.total){
            this.num+=1;
            this.search_sever(this.records,this.num)
        }
    },
    Last_pag(){
        if(this.page<this.total){
            this.search_sever(this.records,this.total)
        }    
    },
  },
  components: {
     
  },
  directives: {
      drag: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('head')[0];
          dragBox.onmousedown = e => {
            //算出鼠标相对元素的位置
            let disX = e.clientX - drag_Box.offsetLeft;
            let disY = e.clientY - drag_Box.offsetTop;
            document.onmousemove = e => {
              //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              let left = e.clientX - disX;
              let top = e.clientY - disY;
              //移动当前元素
              drag_Box.style.left = left + "px";
              drag_Box.style.top = top + "px";
            };
            document.onmouseup = e => {
              //鼠标弹起来的时候不再移动
              document.onmousemove = null;
              //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
              document.onmouseup = null;
            };
          };
        }
      }
    }
}
</script>
<style scoped>
.scroll-tbody{
    height: 400px;
    overflow: auto;
    margin-top: -18px;
}
.head{
    background: #ebecf0;
    height: 40px;
    cursor: move;
}
.head-p{
    line-height: 40px;
    margin-left: 20px;
}
.modal-content{
    position: fixed;
    border: 1px solid #c1c1c1;
    width: 690px;
    height: 650px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.td-width{
  overflow: hidden;
  text-overflow: ellipsis;
}
td{
  font-size: 12px;
}
.footer{
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  /* position: fixed; */
  /* bottom: 5px; */
}
.fa{
  color: #007bff;
  padding: 10px;
  cursor: pointer;
}
.page{
  padding: 10px;
}

   .modal-content{
     /* border: none; */
   }
   .table{
       margin-top: 10px;
       font-size: 14px;
       width: 568px;
   }
   .table thead tr{
     color:#007bff;
   }
   .form-control{
       margin-right: 10px;
       width: 140px;
       height: 30px;
       font-size: 13px;
   }
   .lab{
       margin-right: 10px;
   }
   .form-inline{
       font-size: 14px;
   }
  .text{
    margin: 0 auto;
    display: block;
    outline: none;
  }
  .modal-header{
	background:#ebecf0;
	height:40px
	}
  .modal-span{
	font-size:20px;
	margin-top:-14px;
	cursor:pointer
	}
  .shop{
    margin-left: 20px;
  }
  .modal-title{
	line-height:1px
	}
  .btn-default-close{
    color:#007bff;
	font-size:12px;
	border:1px solid #808080;
	padding:4px;
	margin-right: 93%;
    }
  .btn-default-determine{
    color:#007bff;
	font-size:12px;
	border: 1px solid rgb(128, 128, 128);
	padding: 4px;
    }
    .list {
		padding-top: 50px;
		padding-right: 20px;
    z-index:999
	}
</style>